/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ProjectSubmittedRouteImport } from './routes/project-submitted'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as ManagerDashboardRouteImport } from './routes/manager-dashboard'
import { Route as GrantsDeckRouteImport } from './routes/grants-deck'
import { Route as DealsRouteImport } from './routes/deals'
import { Route as ActivateManagerRouteImport } from './routes/activate-manager'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as KolsIndexRouteImport } from './routes/kols/index'
import { Route as DealsIndexRouteImport } from './routes/deals/index'
import { Route as OnboardingSuccessRouteImport } from './routes/onboarding/success'
import { Route as OnboardingEditRouteImport } from './routes/onboarding/edit'
import { Route as KolsKolSlugRouteImport } from './routes/kols/$kolSlug'
import { Route as JoinSlugRouteImport } from './routes/join.$slug'
import { Route as DealsDealSlugRouteImport } from './routes/deals/$dealSlug'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as SysMgmtSegmentRouteImport } from './routes/sys.mgmt.$segment'
import { Route as SysMgmtSegmentIndexRouteImport } from './routes/sys.mgmt.$segment.index'
import { Route as SysMgmtSegmentProjectsProjectIdRouteImport } from './routes/sys.mgmt.$segment.projects.$projectId'
import { Route as SysMgmtSegmentLiveKolsKolIdRouteImport } from './routes/sys.mgmt.$segment.live-kols.$kolId'
import { Route as SysMgmtSegmentKolsKolIdRouteImport } from './routes/sys.mgmt.$segment.kols.$kolId'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectSubmittedRoute = ProjectSubmittedRouteImport.update({
  id: '/project-submitted',
  path: '/project-submitted',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagerDashboardRoute = ManagerDashboardRouteImport.update({
  id: '/manager-dashboard',
  path: '/manager-dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const GrantsDeckRoute = GrantsDeckRouteImport.update({
  id: '/grants-deck',
  path: '/grants-deck',
  getParentRoute: () => rootRouteImport,
} as any)
const DealsRoute = DealsRouteImport.update({
  id: '/deals',
  path: '/deals',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivateManagerRoute = ActivateManagerRouteImport.update({
  id: '/activate-manager',
  path: '/activate-manager',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const KolsIndexRoute = KolsIndexRouteImport.update({
  id: '/kols/',
  path: '/kols/',
  getParentRoute: () => rootRouteImport,
} as any)
const DealsIndexRoute = DealsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DealsRoute,
} as any)
const OnboardingSuccessRoute = OnboardingSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingEditRoute = OnboardingEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => OnboardingRoute,
} as any)
const KolsKolSlugRoute = KolsKolSlugRouteImport.update({
  id: '/kols/$kolSlug',
  path: '/kols/$kolSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const JoinSlugRoute = JoinSlugRouteImport.update({
  id: '/join/$slug',
  path: '/join/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DealsDealSlugRoute = DealsDealSlugRouteImport.update({
  id: '/$dealSlug',
  path: '/$dealSlug',
  getParentRoute: () => DealsRoute,
} as any)
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const SysMgmtSegmentRoute = SysMgmtSegmentRouteImport.update({
  id: '/sys/mgmt/$segment',
  path: '/sys/mgmt/$segment',
  getParentRoute: () => rootRouteImport,
} as any)
const SysMgmtSegmentIndexRoute = SysMgmtSegmentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SysMgmtSegmentRoute,
} as any)
const SysMgmtSegmentProjectsProjectIdRoute =
  SysMgmtSegmentProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => SysMgmtSegmentRoute,
  } as any)
const SysMgmtSegmentLiveKolsKolIdRoute =
  SysMgmtSegmentLiveKolsKolIdRouteImport.update({
    id: '/live-kols/$kolId',
    path: '/live-kols/$kolId',
    getParentRoute: () => SysMgmtSegmentRoute,
  } as any)
const SysMgmtSegmentKolsKolIdRoute = SysMgmtSegmentKolsKolIdRouteImport.update({
  id: '/kols/$kolId',
  path: '/kols/$kolId',
  getParentRoute: () => SysMgmtSegmentRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/activate-manager': typeof ActivateManagerRoute
  '/deals': typeof DealsRouteWithChildren
  '/grants-deck': typeof GrantsDeckRoute
  '/manager-dashboard': typeof ManagerDashboardRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/project-submitted': typeof ProjectSubmittedRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/deals/$dealSlug': typeof DealsDealSlugRoute
  '/join/$slug': typeof JoinSlugRoute
  '/kols/$kolSlug': typeof KolsKolSlugRoute
  '/onboarding/edit': typeof OnboardingEditRoute
  '/onboarding/success': typeof OnboardingSuccessRoute
  '/deals/': typeof DealsIndexRoute
  '/kols': typeof KolsIndexRoute
  '/sys/mgmt/$segment': typeof SysMgmtSegmentRouteWithChildren
  '/sys/mgmt/$segment/': typeof SysMgmtSegmentIndexRoute
  '/sys/mgmt/$segment/kols/$kolId': typeof SysMgmtSegmentKolsKolIdRoute
  '/sys/mgmt/$segment/live-kols/$kolId': typeof SysMgmtSegmentLiveKolsKolIdRoute
  '/sys/mgmt/$segment/projects/$projectId': typeof SysMgmtSegmentProjectsProjectIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/activate-manager': typeof ActivateManagerRoute
  '/grants-deck': typeof GrantsDeckRoute
  '/manager-dashboard': typeof ManagerDashboardRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/project-submitted': typeof ProjectSubmittedRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof AuthenticatedDashboardRoute
  '/deals/$dealSlug': typeof DealsDealSlugRoute
  '/join/$slug': typeof JoinSlugRoute
  '/kols/$kolSlug': typeof KolsKolSlugRoute
  '/onboarding/edit': typeof OnboardingEditRoute
  '/onboarding/success': typeof OnboardingSuccessRoute
  '/deals': typeof DealsIndexRoute
  '/kols': typeof KolsIndexRoute
  '/sys/mgmt/$segment': typeof SysMgmtSegmentIndexRoute
  '/sys/mgmt/$segment/kols/$kolId': typeof SysMgmtSegmentKolsKolIdRoute
  '/sys/mgmt/$segment/live-kols/$kolId': typeof SysMgmtSegmentLiveKolsKolIdRoute
  '/sys/mgmt/$segment/projects/$projectId': typeof SysMgmtSegmentProjectsProjectIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/activate-manager': typeof ActivateManagerRoute
  '/deals': typeof DealsRouteWithChildren
  '/grants-deck': typeof GrantsDeckRoute
  '/manager-dashboard': typeof ManagerDashboardRoute
  '/onboarding': typeof OnboardingRouteWithChildren
  '/privacy': typeof PrivacyRoute
  '/project-submitted': typeof ProjectSubmittedRoute
  '/terms': typeof TermsRoute
  '/_authenticated/dashboard': typeof AuthenticatedDashboardRoute
  '/deals/$dealSlug': typeof DealsDealSlugRoute
  '/join/$slug': typeof JoinSlugRoute
  '/kols/$kolSlug': typeof KolsKolSlugRoute
  '/onboarding/edit': typeof OnboardingEditRoute
  '/onboarding/success': typeof OnboardingSuccessRoute
  '/deals/': typeof DealsIndexRoute
  '/kols/': typeof KolsIndexRoute
  '/sys/mgmt/$segment': typeof SysMgmtSegmentRouteWithChildren
  '/sys/mgmt/$segment/': typeof SysMgmtSegmentIndexRoute
  '/sys/mgmt/$segment/kols/$kolId': typeof SysMgmtSegmentKolsKolIdRoute
  '/sys/mgmt/$segment/live-kols/$kolId': typeof SysMgmtSegmentLiveKolsKolIdRoute
  '/sys/mgmt/$segment/projects/$projectId': typeof SysMgmtSegmentProjectsProjectIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/activate-manager'
    | '/deals'
    | '/grants-deck'
    | '/manager-dashboard'
    | '/onboarding'
    | '/privacy'
    | '/project-submitted'
    | '/terms'
    | '/dashboard'
    | '/deals/$dealSlug'
    | '/join/$slug'
    | '/kols/$kolSlug'
    | '/onboarding/edit'
    | '/onboarding/success'
    | '/deals/'
    | '/kols'
    | '/sys/mgmt/$segment'
    | '/sys/mgmt/$segment/'
    | '/sys/mgmt/$segment/kols/$kolId'
    | '/sys/mgmt/$segment/live-kols/$kolId'
    | '/sys/mgmt/$segment/projects/$projectId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/activate-manager'
    | '/grants-deck'
    | '/manager-dashboard'
    | '/onboarding'
    | '/privacy'
    | '/project-submitted'
    | '/terms'
    | '/dashboard'
    | '/deals/$dealSlug'
    | '/join/$slug'
    | '/kols/$kolSlug'
    | '/onboarding/edit'
    | '/onboarding/success'
    | '/deals'
    | '/kols'
    | '/sys/mgmt/$segment'
    | '/sys/mgmt/$segment/kols/$kolId'
    | '/sys/mgmt/$segment/live-kols/$kolId'
    | '/sys/mgmt/$segment/projects/$projectId'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/activate-manager'
    | '/deals'
    | '/grants-deck'
    | '/manager-dashboard'
    | '/onboarding'
    | '/privacy'
    | '/project-submitted'
    | '/terms'
    | '/_authenticated/dashboard'
    | '/deals/$dealSlug'
    | '/join/$slug'
    | '/kols/$kolSlug'
    | '/onboarding/edit'
    | '/onboarding/success'
    | '/deals/'
    | '/kols/'
    | '/sys/mgmt/$segment'
    | '/sys/mgmt/$segment/'
    | '/sys/mgmt/$segment/kols/$kolId'
    | '/sys/mgmt/$segment/live-kols/$kolId'
    | '/sys/mgmt/$segment/projects/$projectId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ActivateManagerRoute: typeof ActivateManagerRoute
  DealsRoute: typeof DealsRouteWithChildren
  GrantsDeckRoute: typeof GrantsDeckRoute
  ManagerDashboardRoute: typeof ManagerDashboardRoute
  OnboardingRoute: typeof OnboardingRouteWithChildren
  PrivacyRoute: typeof PrivacyRoute
  ProjectSubmittedRoute: typeof ProjectSubmittedRoute
  TermsRoute: typeof TermsRoute
  JoinSlugRoute: typeof JoinSlugRoute
  KolsKolSlugRoute: typeof KolsKolSlugRoute
  KolsIndexRoute: typeof KolsIndexRoute
  SysMgmtSegmentRoute: typeof SysMgmtSegmentRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/project-submitted': {
      id: '/project-submitted'
      path: '/project-submitted'
      fullPath: '/project-submitted'
      preLoaderRoute: typeof ProjectSubmittedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manager-dashboard': {
      id: '/manager-dashboard'
      path: '/manager-dashboard'
      fullPath: '/manager-dashboard'
      preLoaderRoute: typeof ManagerDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/grants-deck': {
      id: '/grants-deck'
      path: '/grants-deck'
      fullPath: '/grants-deck'
      preLoaderRoute: typeof GrantsDeckRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals': {
      id: '/deals'
      path: '/deals'
      fullPath: '/deals'
      preLoaderRoute: typeof DealsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activate-manager': {
      id: '/activate-manager'
      path: '/activate-manager'
      fullPath: '/activate-manager'
      preLoaderRoute: typeof ActivateManagerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kols/': {
      id: '/kols/'
      path: '/kols'
      fullPath: '/kols'
      preLoaderRoute: typeof KolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals/': {
      id: '/deals/'
      path: '/'
      fullPath: '/deals/'
      preLoaderRoute: typeof DealsIndexRouteImport
      parentRoute: typeof DealsRoute
    }
    '/onboarding/success': {
      id: '/onboarding/success'
      path: '/success'
      fullPath: '/onboarding/success'
      preLoaderRoute: typeof OnboardingSuccessRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/edit': {
      id: '/onboarding/edit'
      path: '/edit'
      fullPath: '/onboarding/edit'
      preLoaderRoute: typeof OnboardingEditRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/kols/$kolSlug': {
      id: '/kols/$kolSlug'
      path: '/kols/$kolSlug'
      fullPath: '/kols/$kolSlug'
      preLoaderRoute: typeof KolsKolSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/join/$slug': {
      id: '/join/$slug'
      path: '/join/$slug'
      fullPath: '/join/$slug'
      preLoaderRoute: typeof JoinSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/deals/$dealSlug': {
      id: '/deals/$dealSlug'
      path: '/$dealSlug'
      fullPath: '/deals/$dealSlug'
      preLoaderRoute: typeof DealsDealSlugRouteImport
      parentRoute: typeof DealsRoute
    }
    '/_authenticated/dashboard': {
      id: '/_authenticated/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthenticatedDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/sys/mgmt/$segment': {
      id: '/sys/mgmt/$segment'
      path: '/sys/mgmt/$segment'
      fullPath: '/sys/mgmt/$segment'
      preLoaderRoute: typeof SysMgmtSegmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sys/mgmt/$segment/': {
      id: '/sys/mgmt/$segment/'
      path: '/'
      fullPath: '/sys/mgmt/$segment/'
      preLoaderRoute: typeof SysMgmtSegmentIndexRouteImport
      parentRoute: typeof SysMgmtSegmentRoute
    }
    '/sys/mgmt/$segment/projects/$projectId': {
      id: '/sys/mgmt/$segment/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/sys/mgmt/$segment/projects/$projectId'
      preLoaderRoute: typeof SysMgmtSegmentProjectsProjectIdRouteImport
      parentRoute: typeof SysMgmtSegmentRoute
    }
    '/sys/mgmt/$segment/live-kols/$kolId': {
      id: '/sys/mgmt/$segment/live-kols/$kolId'
      path: '/live-kols/$kolId'
      fullPath: '/sys/mgmt/$segment/live-kols/$kolId'
      preLoaderRoute: typeof SysMgmtSegmentLiveKolsKolIdRouteImport
      parentRoute: typeof SysMgmtSegmentRoute
    }
    '/sys/mgmt/$segment/kols/$kolId': {
      id: '/sys/mgmt/$segment/kols/$kolId'
      path: '/kols/$kolId'
      fullPath: '/sys/mgmt/$segment/kols/$kolId'
      preLoaderRoute: typeof SysMgmtSegmentKolsKolIdRouteImport
      parentRoute: typeof SysMgmtSegmentRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedDashboardRoute: typeof AuthenticatedDashboardRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface DealsRouteChildren {
  DealsDealSlugRoute: typeof DealsDealSlugRoute
  DealsIndexRoute: typeof DealsIndexRoute
}

const DealsRouteChildren: DealsRouteChildren = {
  DealsDealSlugRoute: DealsDealSlugRoute,
  DealsIndexRoute: DealsIndexRoute,
}

const DealsRouteWithChildren = DealsRoute._addFileChildren(DealsRouteChildren)

interface OnboardingRouteChildren {
  OnboardingEditRoute: typeof OnboardingEditRoute
  OnboardingSuccessRoute: typeof OnboardingSuccessRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingEditRoute: OnboardingEditRoute,
  OnboardingSuccessRoute: OnboardingSuccessRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

interface SysMgmtSegmentRouteChildren {
  SysMgmtSegmentIndexRoute: typeof SysMgmtSegmentIndexRoute
  SysMgmtSegmentKolsKolIdRoute: typeof SysMgmtSegmentKolsKolIdRoute
  SysMgmtSegmentLiveKolsKolIdRoute: typeof SysMgmtSegmentLiveKolsKolIdRoute
  SysMgmtSegmentProjectsProjectIdRoute: typeof SysMgmtSegmentProjectsProjectIdRoute
}

const SysMgmtSegmentRouteChildren: SysMgmtSegmentRouteChildren = {
  SysMgmtSegmentIndexRoute: SysMgmtSegmentIndexRoute,
  SysMgmtSegmentKolsKolIdRoute: SysMgmtSegmentKolsKolIdRoute,
  SysMgmtSegmentLiveKolsKolIdRoute: SysMgmtSegmentLiveKolsKolIdRoute,
  SysMgmtSegmentProjectsProjectIdRoute: SysMgmtSegmentProjectsProjectIdRoute,
}

const SysMgmtSegmentRouteWithChildren = SysMgmtSegmentRoute._addFileChildren(
  SysMgmtSegmentRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ActivateManagerRoute: ActivateManagerRoute,
  DealsRoute: DealsRouteWithChildren,
  GrantsDeckRoute: GrantsDeckRoute,
  ManagerDashboardRoute: ManagerDashboardRoute,
  OnboardingRoute: OnboardingRouteWithChildren,
  PrivacyRoute: PrivacyRoute,
  ProjectSubmittedRoute: ProjectSubmittedRoute,
  TermsRoute: TermsRoute,
  JoinSlugRoute: JoinSlugRoute,
  KolsKolSlugRoute: KolsKolSlugRoute,
  KolsIndexRoute: KolsIndexRoute,
  SysMgmtSegmentRoute: SysMgmtSegmentRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

// Auto-generated by TanStack Router
